import { AppData } from "../AppDataProvider";
import { NavigateToWaitlistPayload } from "../actions";
import { Mixpanel } from "../../mixpanel";

export type NavigateToWaitlistOpts = {
  appData: AppData;
  payload: NavigateToWaitlistPayload;
};

export const navigateToWaitlist = (
  options: NavigateToWaitlistOpts,
): AppData => {
  Mixpanel.track({ name: "Completed step", props: { step: "availability" } });

  return {
    ...options.appData,
    currentStep: "waitlist",
    waitlistBooking: options.payload.updatedData,
  };
};

export type CompleteWaitlistOpts = {
  appData: AppData;
};

export const completeWaitlist = (options: CompleteWaitlistOpts): AppData => {
  Mixpanel.track({ name: "Completed step", props: { step: "waitlist" } });

  return {
    ...options.appData,
    currentStep: "waitlistConfirmation",
  };
};

export type BackFromWaitlistStepOpts = {
  appData: AppData;
};

export const backFromWaitlistStep = (
  options: BackFromWaitlistStepOpts,
): AppData => {
  Mixpanel.track({ name: "Went back", props: { from: "waitlist" } });

  return {
    ...options.appData,
    currentStep: "availability",
    waitlistBooking: undefined,
  };
};
